import React from "react";
import { ControllerRenderProps, FieldError } from "react-hook-form";

type CustomRankingInputProps = {
  label: string;
  placeholder?: string;
  helperText?: string;
  field: ControllerRenderProps<any, any>;
  fieldState: { error?: FieldError };
  type?: React.HTMLInputTypeAttribute | "textarea";
  rows?: number;
  name?: string;
  value?: string;
  
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
};

const CustomRankingInput: React.FC<CustomRankingInputProps> = ({
  label,
  placeholder,
  helperText,
  field,
  fieldState,
  type = "text",
  name,
  rows = 4,
  value,
  onChange,
}) => {
  const { onBlur, ref } = field;
  const { error } = fieldState;

  const renderInput = () => {
    if (type === "textarea") {
      return (
        <textarea
          id={name}
          name={name}
          placeholder={placeholder}
          value={field.value || ""}
          onChange={field.onChange}
          onBlur={onBlur}
          ref={ref}
          rows={rows}
          className={`appearance-none border ${
            error ? "border-red-500" : "border-gray-300"
          } rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline resize-none`}
        />
      );
    }
    return (
      <input
        id={name}
        name={name}
        type={type}
        placeholder={placeholder}
        value={field?.value || (type === "number" ? "" : "")}
        onChange={field?.onChange}
        onBlur={onBlur}
        ref={ref}
        className={`appearance-none border ${
          error ? "border-red-500" : "border-gray-300"
        } rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
      />
    );
  };

  return (
    <div className="">
      <label
        htmlFor={name}
        className="block text-[#194E5B] text-sm font-semibold"
      >
        {label}
      </label>
      {renderInput()}
      {(helperText || error) && (
        <p
          className={`text-xs mt-1 ${error ? "text-red-500" : "text-gray-600"}`}
        >
          {error ? error.message : helperText}
        </p>
      )}
    </div>
  );
};

export default CustomRankingInput;
